import React from 'react';
import classnames from 'classnames';
import { useDropzone } from 'react-dropzone';

import './files-dropzone-component.scss';
import { NO_OP } from '../../../constants';

const DEFAULT_MAX_FILES = 100;

export default function FilesDropzoneComponent({
  maxFiles = DEFAULT_MAX_FILES,
  containerClassname = '',
  overrideContainerStyles = false,
  placeholder = '',
  placeholderClassname = '',
  overridePlaceholderStyles = false,
  acceptFileTypes = [],
  onFilesDrop = NO_OP,
  children,
  disabled = false,
  multiple = true,
  maxSize,
}) {
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles,
    accept: acceptFileTypes.join(','),
    onDrop: onFilesDrop,
    disabled,
    multiple,
    maxSize,
  });

  return (
    <div className={classnames(containerClassname, { 'files-dropzone-component': !overrideContainerStyles })}>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        {children || (
          <div className={classnames(placeholderClassname, { placeholder: !overridePlaceholderStyles })}>
            {placeholder}
          </div>
        )}
      </div>
    </div>
  );
}
